import { GraphQLRequestClient } from '@sitecore-jss/sitecore-jss-nextjs/graphql';
import graphqlClientFactory from 'lib/graphql-client-factory';
import {
  RichTextFragment,
  TeamMemberSearchDocument,
  TeamMemberSearchFragment,
  TeamMemberSearchQuery,
  TeamMemberSearchQueryVariables,
} from './queries/TeamMemberSearch.graphql';
import {
  TeamMemberMetadataDocument,
  TeamMemberMetadataFragment,
  TeamMemberMetadataQuery,
  TeamMemberMetadataQueryVariables,
} from './queries/TeamMemberMetadata.graphql';

function isTeamMember(o: any): o is TeamMemberSearchFragment {
  return o?.__typename === 'TeamMember';
}
function isTeamMemberMeta(o: any): o is TeamMemberMetadataFragment {
  return o?.__typename === 'TeamMember';
}

function isRichText(o: any): o is RichTextFragment {
  return o?.__typename === 'RichText_efcfd8f6596745f48f85b5421928205d';
}

export type TeamMember = Omit<TeamMemberSearchFragment, 'bio'> & {
  bio: RichTextFragment[];
};

class TeamMemberService {
  constructor(private readonly graphQLClient: GraphQLRequestClient) {}

  private getTeamMemberName(slug: string): string {
    return slug.replace(/-/g, ' ');
  }
  public async getTeamMember(slug: string, language: string): Promise<TeamMember | undefined> {
    if (!slug) return;
    const teamMemberName = this.getTeamMemberName(slug);

    const queryParams: TeamMemberSearchQueryVariables = {
      teamMemberName,
      language,
    };
    const result = await this.graphQLClient.request<TeamMemberSearchQuery>(
      TeamMemberSearchDocument,
      queryParams
    );

    const teamMember = result?.search?.results?.[0];
    if (!isTeamMember(teamMember)) return;
    const bio = teamMember.bio?.results.filter(isRichText) ?? [];
    return { ...teamMember, bio };
  }
  public async getTeamMemberMeta(
    slug: string,
    language: string
  ): Promise<TeamMemberMetadataFragment | undefined> {
    if (!slug) return;
    const teamMemberName = this.getTeamMemberName(slug);

    const queryParams: TeamMemberMetadataQueryVariables = {
      teamMemberName,
      language,
    };
    const result = await this.graphQLClient.request<TeamMemberMetadataQuery>(
      TeamMemberMetadataDocument,
      queryParams
    );

    const teamMemberMeta = result?.search?.results?.[0];
    if (!isTeamMemberMeta(teamMemberMeta)) return;
    return teamMemberMeta;
  }
}

export const teamMemberService = new TeamMemberService(graphqlClientFactory());
